import logo from './logo.svg';
import './App.css';
import Header from './components/header';
import Topfooter from './components/topfooter';
import Footer from './components/footer';
import AllRoutes from './components/AllRoutes';

function App() {
  return (
    <div className="App">
      <Header/>
      <AllRoutes/>
      <Topfooter/>
      <Footer/>
    </div>
  );
}

export default App;

{/* <LandingPage/> */}
{/*  */}
{/* <LandingPage/> */}
{/* 
    <SingleProduct/>  */}

{/* <Product/> */}